import * as React from 'react';
import { useContext } from 'react';

import { TemporaryDrawer } from '@coursera/cds-core';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import LearnerItemSettingExceptions from 'bundles/author-assignment-grading/components/common/components/LearnerItemSettingExceptions';
import type LegacyTeam from 'bundles/author-assignment-grading/components/common/types/Team';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';

type Props = {
  legacyTeam?: LegacyTeam;
};

// Component for the Item Setting Exceptions Drawer's contents
const ContentContainer: React.FC<Props> = ({ legacyTeam }) => {
  const { pageData, submissionData } = useContext(SGAPageContext);
  const { Content } = TemporaryDrawer;

  return (
    <Content data-testid="item-setting-exceptions-content">
      <LearnerItemSettingExceptions
        currentItem={pageData.currentItem}
        proctorConfigDraft={pageData.proctorConfigDraft}
        sessionItem={pageData.sessionItem}
        grade={pageData.gradebookGrades[submissionData.data?.submitter?.id || '']}
        userId={submissionData.data?.submitter?.id || ''}
        courseId={pageData.courseId}
        isTeamProject={submissionData.data?.isTeamAssignment}
        team={legacyTeam}
        refetchSessionItem
      />
    </Content>
  );
};

export default ContentContainer;
